import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Spinner from "helpers/Spinner";
import { PUT_IMPORT } from 'helpers/request'

import { import_current_tab, import_set_data, import_success_import} from './store'
import LanguageHelper from 'helpers/language_helper'


class ImportFileStep2 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    activeModalRecurso: false,
    selResource: -1,
  }
  refSelResource = null
  constructor(props) {
    super(props)
    console.log('Constructo step2')
    this.refSelResource = createRef()
  }
  componentDidUpdate(props, state) {
    console.log('update import step 2', state, this.state)
    console.log('update import step 2', props, this.props)

  }

  componentDidMount() {
    console.log('mounted step2', this.state, this.props)
    // this.props.import_set_data({resource: 999999})

  }
  disabledProcesar = () => {
    return +this.state.selResource !== -1
  }
  OnClick_openModal = () => {

    this.setState({
      activeModalRecurso: true
    })
  }
  onChange = (evt) => {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;



    this.setState({
      [evt.target.name]: value,
    });
  }
  textprueba = () => {
    // console.log(this.props)
    // console.log(this.state)
    return this.props.currentTab;
  }

  

  onSubmit_Step2 = async (event) => {
    event.preventDefault()
   
        // let sendData = this.state
        Spinner.show()
        this.props.import_current_tab(3)
        await PUT_IMPORT({
          table: this.props.importData.table
          },`indicators/importIndicators/`,this.props.importData.idFileName).then(res => {
        Spinner.hide()
          if (res.success) {
            this.props.import_success_import({
              registros: res.totalrows,
              tiempo: res.time,
              successRow: res.successRows,
              failRow: res.errorRows,
              linkFileError: res.errorFileName,
              linkSuccess: res.localUrl,
              listErrors: res.errorMess,
              haveError: res.haveError
            })
          
          }
        
        }).catch(err => //Spinner.hide()
        console.log("error")
        )
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
      
        <form id="frmImportStep2" onSubmit={this.onSubmit_Step2}>

          <div className="field ">

            <p className="card-header-title">
              <span className="icon"><i className="mdi mdi-finance"></i></span>
              {LanguageHelper.getLanguageString('ImportIndicators2.indicator')}: {this.props.importData.typeInformationName}
            </p>
            <p className="card-header-title">
              <span className="icon"><i className="mdi mdi-finance"></i></span>
              {LanguageHelper.getLanguageString('ImportIndicators2.file')}: {this.props.importData.fileName}
            </p>
            {this.props.importData.successTemplate ? "" :
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorNoData')}
                </p>
            }
            {this.props.importData.errorCodCountries ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCountrie')}
                </p> : ""
            }

            {this.props.importData.errorCatOne ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCat1')}
                </p> : ""
            }

            {this.props.importData.errorCatTwo ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCat2')}
                </p> : ""
            }

            {this.props.importData.errorCatThree ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCat3')}
                </p> : ""
            }

            {this.props.importData.errorCatFour ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCat4')}
                </p> : ""
            }

            {this.props.importData.errorCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorCat5')}
                </p> : ""
            }

            {this.props.importData.errorNotCatOne ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParCat1')}</p> : ""
            }

            {this.props.importData.errorNotCatTwo ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParCat2')}</p> : ""
            }

            {this.props.importData.errorNotCatThree ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParCat3')}</p> : ""
            }

            {this.props.importData.errorNotCatFour ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParCat4')}</p> : ""
            }

            {this.props.importData.errorNotCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParCat5')}</p> : ""
            }

            {this.props.importData.errorNotCatSubCatOne ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParSub1')}</p> : ""
            }

            {this.props.importData.errorNotCatSubCatTwo ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParSub2')}</p> : ""
            }

            {this.props.importData.errorNotCatSubCatThree ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParSub3')}</p> : ""
            }

            {this.props.importData.errorNotCatSubCatFour ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParSub4')}</p> : ""
            }

            {this.props.importData.errorNotCatSubCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorParSub5')}</p> : ""
            }

            {this.props.importData.errorSubCatOne ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorSub1')}
                </p> : ""
            }

            {this.props.importData.errorSubCatTwo ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorSub2')}
                </p> : ""
            }

            {this.props.importData.errorSubCatThree ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorSub3')}
                </p> : ""
            }

            {this.props.importData.errorSubCatFour ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorSub4')}
                </p> : ""
            }

            {this.props.importData.errorSubCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorSub5')}
                </p> : ""
            }

            {this.props.importData.errorNotSubCatOne ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorPSub1')}</p> : ""
            }

            {this.props.importData.errorNotSubCatTwo ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorPSub2')}</p> : ""
            }

            {this.props.importData.errorNotSubCatThree ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorPSub3')}</p> : ""
            }

            {this.props.importData.errorNotSubCatFour ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorPSub4')}</p> : ""
            }

            {this.props.importData.errorNotSubCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.errorPSub5')}</p> : ""
            }
            {this.props.importData.successTemplate && !this.props.importData.errorCodCountries && !this.props.importData.errorCatOne && !this.props.importData.errorCatTwo && !this.props.importData.errorCatThree && !this.props.importData.errorCatFour && !this.props.importData.errorCatFive && !this.props.importData.errorNotCatOne && !this.props.importData.errorNotCatTwo && !this.props.importData.errorNotCatThree && !this.props.importData.errorNotCatFour && !this.props.importData.errorNotCatFive && !this.props.importData.errorSubCatOne && !this.props.importData.errorSubCatTwo && !this.props.importData.errorSubCatThree && !this.props.importData.errorSubCatFour && !this.props.importData.errorSubCatFive && !this.props.importData.errorNotSubCatOne && !this.props.importData.errorNotSubCatTwo && !this.props.importData.errorNotSubCatThree && !this.props.importData.errorNotSubCatFour && !this.props.importData.errorNotSubCatFive && !this.props.importData.errorNotCatSubCatOne && !this.props.importData.errorNotCatSubCatTwo && !this.props.importData.errorNotCatSubCatThree && !this.props.importData.errorNotCatSubCatFour && !this.props.importData.errorNotCatSubCatFive ?
              <p >
                <span className="icon"><i className="mdi mdi-finance"></i></span>
                {LanguageHelper.getLanguageString('ImportIndicators2.success')}</p> : ""
            }
          </div>

          <hr />


          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">

                      <div className="control">
                        <button type="submit" disabled={!(this.props.importData.successTemplate && !this.props.importData.errorCodCountries && !this.props.importData.errorCatOne && !this.props.importData.errorCatTwo && !this.props.importData.errorCatThree && !this.props.importData.errorCatFour && !this.props.importData.errorCatFive && !this.props.importData.errorNotCatOne && !this.props.importData.errorNotCatTwo && !this.props.importData.errorNotCatThree && !this.props.importData.errorNotCatFour && !this.props.importData.errorNotCatFive && !this.props.importData.errorSubCatOne && !this.props.importData.errorSubCatTwo && !this.props.importData.errorSubCatThree && !this.props.importData.errorSubCatFour && !this.props.importData.errorSubCatFive && !this.props.importData.errorNotSubCatOne && !this.props.importData.errorNotSubCatTwo && !this.props.importData.errorNotSubCatThree && !this.props.importData.errorNotSubCatFour && !this.props.importData.errorNotSubCatFive && !this.props.importData.errorNotCatSubCatOne && !this.props.importData.errorNotCatSubCatTwo && !this.props.importData.errorNotCatSubCatThree && !this.props.importData.errorNotCatSubCatFour && !this.props.importData.errorNotCatSubCatFive)} className="button is-primary">
                          <span>{LanguageHelper.getLanguageString('ImportIndicators2.submit')}</span>
                        </button></div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>

        </form>

      </div>
    )
  }
}

const mapStateToProps = (state, props /*, ownProps*/) => {
  console.log('mapStateToProps import2', state)
  return {
    currentTab: state.reducerTab.tab,
    importData: state.reducerData

  }
}
export default connect(mapStateToProps, { import_current_tab, import_set_data, import_success_import })(ImportFileStep2)